import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateTrainingRegistrationFeedback = ({ id, input }) => {
  const mutation = require("../api/mutation/updateTrainingRegistrationFeedback.gql");
  const variables = { id, input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.updateTrainingRegistrationFeedback };
    else if (error) return { error: JSON.stringify(error) };
  });
};
